module.exports = __webpack_public_path__ + "static/img/ks.a4cb9e90.png";